import * as actionTypes from "../actions/actionTypes";
import type { CartAction } from "../actions/cart";
import type { CartState } from "../../types/orders";

const initialState: CartState = { cart: [], orderDetails: null };

export default function cartReducer(
  state: CartState = initialState,
  action: CartAction | { type: string },
): CartState {
  switch (action.type) {
    case actionTypes.SET_CART:
      return {
        ...state,
        cart: Array.isArray((action as Extract<CartAction, { type: typeof actionTypes.SET_CART }>).cart)
          ? (action as Extract<CartAction, { type: typeof actionTypes.SET_CART }>).cart
          : [],
      };
    case actionTypes.SET_ORDER_DETAILS:
      return {
        ...state,
        orderDetails: (action as Extract<CartAction, { type: typeof actionTypes.SET_ORDER_DETAILS }>).orderDetails,
      };
    default:
      return state;
  }
}
